module.exports = {
      id: "cross-usage",
      viewBox: "0 0 12 12",
      url: __webpack_public_path__ + "assets/img/sprite-6589e8.svg#cross-usage",
      toString: function () {
        return this.url;
      }
    }